import IdleMonitor from "./IdleMonitor";

export default IdleMonitor;